import linq from 'linq'
import { snakeToCamel, camelToSnake } from '../utility/stringUtility'
import Model from './Parents/Model'
import UserDeliveryAddress from './UserDeliveryAddress'
import Order from './Order'
import UserAddress from './UserAddress'

const FILLABEL = [
    'id',
    'name',
    'nameKana',
    'type',
    'email',
    'tel',
    'password',
    'deliveryAddresses',
    'changeEmail',
    'changePassword',
    'changePasswordConfirmation',
    'addAddress',
    'default',
    'orders',
    'address',
    'familyName',
    'firstName',
    'company',
]

const PRESENTS = ['type']

export const USER_TYPE_GENERAL = 0
export const USER_TYPE_CONTRACT_BEFORE = 1
export const USER_TYPE_CONTRACT_10_DISCOUNT = 2
export const USER_TYPE_CONTRACT_30_DISCOUNT = 3
export const USER_TYPE_CONTRACT_CROSS_50_OTHER_30_DISCOUNT = 4
export const USER_TYPE_CONTRACT_50_DISCOUNT = 5

export const USER_TYPE_CONTRACT_20_DISCOUNT = 6

export const USER_TYPE_CONTRACT_NO_DISCOUNT = 7

export const USER_TYPE_INSIDE_COMPANY = 8

export default class User extends Model {
    constructor(data = null) {
        super()
        this.originalData = data

        this.id = 0
        this.name = ''
        this.nameKana = ''
        this.type = 0
        this.email = ''
        this.tel = ''
        this.password = ''
        this.createdAt = ''

        this.changeEmail = ''
        this.changePassword = ''
        this.changePasswordConfirmation = ''
        this.addAddress = ''
        this.default = 0
        this.verified = ''
        this.orderHistory = false
        this.familyName = ''
        this.firstName = ''
        this.company = ''

        this.userAddress = new UserAddress()
        this.deliveryAddresses = []
        this.orders = []
        this.address = ''
        this.userTypeName = ''
        this.userNumber = '' // 会員番号
        this.userTypeList = []

        if (data) {
            this.create()
        }
    }

    get _model() {
        return 'User'
    }

    get viewEmail() {
        return this.data.email
    }

    get defaultAddress() {
        const address = linq.from(this.deliveryAddresses).firstOrDefault(new UserDeliveryAddress())
        return linq.from(this.deliveryAddresses).firstOrDefault((x) => x.default, address)
    }

    set defaultAddress(val) {
        this.defaultAddress.deliveryAddress = val
    }

    addDelivery(data) {
        if (linq.from(this.deliveryAddresses).any((x) => !x.id)) {
            this.deliveryAddresses = [data]
        } else {
            this.deliveryAddresses.push(data)
        }
    }

    clearPassword() {
        this.changePassword = ''
        this.changePasswordConfirmation = ''
    }

    create() {
        linq.from(this.data)
            .select((x) => {
                x.key = camelToSnake(x.key)
                return x
            })
            .where((x) => this.hasOwnProperty(snakeToCamel(x.key)))
            .select((x) => {
                const key = snakeToCamel(x.key)

                if (typeof this[key] === 'number') {
                    this[key] = Number(x.value)
                    return
                }

                if (x.key === 'delivery_addresses') {
                    if (!x.value.length) return
                    this[key] = linq
                        .from(x.value)
                        .select((x) => new UserDeliveryAddress(x))
                        .toArray()
                    return
                }

                if (x.key === 'orders') {
                    if (!x.value.length) return
                    this[key] = linq
                        .from(x.value)
                        .select((x) => new Order(x))
                        .toArray()
                    return
                }

                if (x.key === 'user_address') {
                    this[key] = new UserAddress(x.value)
                    return
                }

                this[key] = x.value
                return x
            })
            .toArray()
    }

    get data() {
        return this.originalData
    }

    joinWhere(x) {
        return linq.from(PRESENTS).any((xs) => x.key === xs)
    }

    getPostable() {
        return linq
            .from(this)
            .where((x) => linq.from(FILLABEL).any((xs) => xs === x.key))
            .where((x) => x.value || x.key === 'company' || this.joinWhere(x))
            .select((x) => {
                if (x.key === 'deliveryAddresses') {
                    x.value = linq
                        .from(x.value)
                        .where((x) => x.deliveryAddress)
                        .select((x) => x.getPostable())
                        .toArray()
                }

                return {
                    key: camelToSnake(x.key),
                    value: x.value,
                }
            })
            .toObject('$.key', '$.value')
    }

    get defaultDeliveryAddress() {
        if (!this.deliveryAddresses.length) return new UserDeliveryAddress()
        const ad = this.deliveryAddresses.find((x) => x.default === 1)
        return ad ? ad : new UserDeliveryAddress()
    }

    getDeliveryAddressesList() {
        if (!this.deliveryAddresses.length) return []
        return this.deliveryAddresses.filter((x) => !!x.postCode)
    }

    getOldAddress(oldDeliveryAddressId) {
        if (!this.deliveryAddresses.length) return new UserDeliveryAddress()
        const ad = this.deliveryAddresses.find((x) => x.id == oldDeliveryAddressId)
        return ad ? ad : new UserDeliveryAddress()
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/models/User.js